export const OMNI_EBOOK_SEARCH_RESULT_ITEM_TITLE = 'esri press ebooks';
